import { styled } from '@mui/material/styles';

import { CmsSpacingSizes } from '@tgg/common-types';

const sizes: Record<CmsSpacingSizes, number> = {
    [CmsSpacingSizes.Small]: 2.4,
    [CmsSpacingSizes.Medium]: 3.2,
    [CmsSpacingSizes.Large]: 4.8,
};

export const StyledDiv = styled('div')<{
    $spacingBottom?: CmsSpacingSizes;
}>`
    height: ${({ $spacingBottom }) =>
        sizes[$spacingBottom as CmsSpacingSizes] ?? '0'}rem;
`;
